import React from 'react';
import { Box, Chip, Stack } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { useTranslation } from 'react-i18next';
import ClarificationAnswerField from '../Common/ClarificationAnswerField';

const ActionFlowClarifications = ({ questions, inputTypes, answers, caseid, disabled, onAnswer,
  answerMaxLength = 1000, multiline = false, focusFirstUnanswered = false }) => {
  const { t } = useTranslation();
  const firstMissing = questions.findIndex((_question, index) => !String(answers[index] || '').trim());
  return (
    <Stack component="ol" spacing={2} sx={{ listStyle: 'none', m: 0, p: 0, minWidth: 0 }}>
      {questions.map((question, index) => {
        const completed = Boolean(String(answers[index] || '').trim());
        const current = index === firstMissing;
        return (
          <Box component="li" key={`${index}:${question}`} sx={{
            p: { xs: 2, sm: 2.5 }, border: '1px solid', borderRadius: 3, minWidth: 0,
            borderColor: current ? 'primary.main' : 'divider', bgcolor: 'background.paper',
            boxShadow: current ? '0 0 0 3px rgba(87, 87, 176, 0.08)' : 'none',
          }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1.5 }}>
              <Box aria-hidden="true" sx={{
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                width: 28, height: 28, borderRadius: '50%', fontSize: 14, fontWeight: 700,
                bgcolor: completed ? 'success.light' : 'primary.main', color: 'primary.contrastText',
              }}>{completed ? <CheckCircleRoundedIcon sx={{ fontSize: 20 }} /> : index + 1}</Box>
              <Chip size="small" variant="outlined" color={completed ? 'success' : 'primary'}
                label={t(`dag.flow_assistant.clarification_ui.${completed ? 'completed' : 'required'}`)} />
            </Stack>
            <ClarificationAnswerField emphasized required caseid={caseid} inputType={inputTypes?.get(index)}
              autoFocus={focusFirstUnanswered && current}
              label={question} value={answers[index] || ''} disabled={disabled}
              multiline={multiline} minRows={multiline ? 2 : undefined} maxRows={multiline ? 8 : undefined}
              inputProps={{ maxLength: answerMaxLength }} onChange={(value) => onAnswer(index, value)} />
          </Box>
        );
      })}
    </Stack>
  );
};

export default ActionFlowClarifications;
